<template>

  <div class="Journalism">
    <div class="swiper-container Journalismswiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">
            <el-scrollbar ref="Journalismscroll"
                          style="height: 100%">
              <div>
                <div class="information_box">
                  <div class="title_box">新闻资讯</div>
                  <div class="information_list_box">
                    <div class="left_box"
                         v-if="newsList.length>0">
                      <div class="img_box"
                           @click="details(newsList[0].newsId,0)">
                        <img :src="newsList[0].newsImg"
                             alt="">
                      </div>
                      <div class="time_box">
                        <p>{{newsList[0].createTime.substr(0,7)}}</p>
                        <span>{{newsList[0].createTime.substr(8,2)}}</span>
                      </div>
                      <div class="bottom_box">{{newsList[0].newsTitle}}</div>
                    </div>
                    <div class="left_box"
                         v-else></div>

                    <div class="right_box">
                      <div class="right_list_box"
                           v-if="newsList.length>1"
                           @click="details(newsList[1].newsId,1)">
                        <img :src="newsList[1].newsImg"
                             alt="">
                        <div class="time_box">
                          <p>{{newsList[1].createTime.substr(0,7)}}</p>
                          <span>{{newsList[1].createTime.substr(8,2)}}</span>
                        </div>
                        <div class="bottom_box">{{newsList[1].newsTitle}}</div>
                      </div>
                      <div v-else
                           class="right_list_box"></div>

                      <div v-if="newsList.length>2"
                           class="right_list_box"
                           style="margin-top:0.1979rem"
                           @click="details(newsList[2].newsId,2)">
                        <img :src="newsList[2].newsImg"
                             alt="">
                        <div class="time_box">
                          <p>{{newsList[2].createTime.substr(0,7)}}</p>
                          <span>{{newsList[2].createTime.substr(8,2)}}</span>
                        </div>
                        <div class="bottom_box">{{newsList[2].newsTitle}}</div>
                      </div>
                      <div v-else
                           class="right_list_box"
                           style="margin-top:0.1979rem"></div>

                    </div>
                  </div>
                </div>
                <div class="option_box">
                  <div @click="category(0)"
                       :class="JournalismPage == 0?'li liSelected':'li'">
                    全部
                    <div class="Ground"
                         :style="JournalismPage == 0?'opacity: 1;':'opacity: 0;'"></div>
                  </div>

                  <div v-for="item,index in dataList"
                       :key="index">
                    <div @click="category(item.dictValue)"
                         :class="JournalismPage == index +1?'li liSelected':'li'"
                         class="li">
                      {{item.dictLabel}}
                      <div class="Ground"
                           :style="JournalismPage == index +1?'opacity: 1;':'opacity: 0;'"></div>
                    </div>
                  </div>
                </div>
                <div class="Journalism_ul">
                  <div v-for="item,index in newsList"
                       :key="index">
                    <div class="li"
                         @click="details(item.newsId,index)">
                      <div class="time">
                        <div class="year">
                          {{item.createTime.substr(0,7)}}
                        </div>
                        <div class="spot"></div>
                        <div class="day">
                          {{item.createTime.substr(8,2)}}
                        </div>
                      </div>
                      <div class="img_box">
                        <img :src="item.newsImg"
                             alt="">
                      </div>
                      <div class="text">
                        <div class="title"
                             v-if="item.newsTitle.length>20">{{item.newsTitle.substr(0,20)}}...</div>
                        <div class="title"
                             v-else>{{item.newsTitle}}</div>
                        <p v-if="item.newsContent.length>150"
                           v-html="item.newsContent.substr(0,150)"></p>
                        <p v-else
                           v-html="item.newsContent"></p>
                      </div>
                    </div>
                  </div>
                </div>
                <pagination v-show="total>0"
                            :total="total"
                            :page.sync="queryParams.pageNum"
                            :limit.sync="queryParams.pageSize"
                            @pagination="getNewsList" />
              </div>
              <Footer></Footer>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Footer from "@/components/footer.vue";
import Banner from "@/components/banner.vue";
import { listData } from "@/api/dict/data";
import { listNews, getNews } from "@/api/news";
export default {
  computed: {
    JournalismPage: {
      get () {
        return this.$store.state.JournalismPage
      },
      set (value) {
        this.$store.commit('putJournalismPage', value)
      }
    }
  },
  components: {
    Footer,
    Banner
  },
  data () {
    return {
      newsList: [],
      dataList: [],
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 9,
        newsType: '',
        newsAuthor: '',
        newsTitle: null,
        createTime: null
      },
      scrollTop: 0,
      jieliu: true,
      JournalismswiperId: 0,
      Journalismswiper: '',
    };
  },
  watch: {
    JournalismswiperId: {
      handler (e) {
        if (e == 1) {
          this.$refs.Journalismscroll.wrap.scrollTop = 1
          this.Journalismswiper.disableMousewheelControl()
        }
      }
    },
    JournalismPage: {
      handler (e) {
        if (e !== this.JournalismswiperId) {
          this.Journalismswiper.slideTo(1)
        }
      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.Journalismscroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.Journalismswiper.slidePrev()
        _this.Journalismswiper.enableMousewheelControl()
      }
    }
    this.Journalismswiper = new Swiper('.Journalismswiper', {
      initialSlide: _this.JournalismPage,
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 700, // 每次切换时长
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.JournalismswiperId = swiper.activeIndex
      }
    })
    this.getDictList();
    this.getNewsList();
  },
  methods: {
    getNewsList () {
      listNews(this.queryParams).then(response => {
        this.newsList = response.rows;
        this.total = response.total;
      });
    },
    getDictList () {
      listData({ dictType: 'news_type' }).then(response => {
        this.dataList = response.rows;
      });
    },
    ...mapMutations(['putJournalismPage']),
    category (row) {
      this.putJournalismPage(row)
      if (row > 0) {
        this.queryParams.newsType = row;
      } else {
        this.queryParams.newsType = null;
      }
      this.getNewsList();
    },
    details (row, index) {
      this.$router.push(
        {
          path: "/Journalism/details",
          query: {
            id: row,
            index: index,
            newsType: this.$store.state.JournalismPage
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.Journalism {
  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .title_info {
    font-size: 0.1146rem;
    font-family: MicrosoftYaHei;
    line-height: 0.2083rem;
    color: #999999;
    opacity: 1;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .information_box {
    .title_box {
      margin-top: 0.6208rem;
      color: #000;
    }
    .information_list_box {
      display: flex;
      margin: 0 1.875rem;
      margin-top: 0.1542rem;
      margin-bottom: 0.1592rem;
      .left_box {
        width: 3.9229rem;
        height: 2.5083rem;
        background: #a1a1a1;
        opacity: 1;
        border-radius: 0px;
        margin-right: 0.1979rem;
        position: relative;
        cursor: pointer;
        .img_box {
          width: 100%;
          height: 100%;
          background-color: skyblue;
          image {
            width: 100%;
            height: 100%;
          }
        }
        .bottom_box {
          position: absolute;
          bottom: 0rem;
          left: 0rem;
          height: 0.276rem;
          background: #00000070;
          width: 3.9229rem;
          line-height: 0.276rem;
          font-size: 0.1458rem;
          color: #fff;
        }
      }
      .time_box {
        position: absolute;
        top: 0rem;
        left: 0rem;
        width: 0.5rem;
        height: 0.4375rem;
        background-color: #ff6100;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 0.0104rem;
        opacity: 1;
        p {
          font-size: 0.0908rem;
          margin-top: 0.0521rem;
        }
        span {
          font-size: 0.1708rem;
          margin-top: 0.0521rem;
        }
      }
      .right_box {
        flex: 1;
        .time_box {
          width: 0.45rem;
          height: 0.3875rem;
          p {
            font-size: 0.0808rem;
            margin-top: 0.0521rem;
          }
          span {
            font-size: 0.1508rem;
            margin-top: 0.0521rem;
          }
        }
        .right_list_box {
          position: relative;
          height: 1.1571rem;
          width: 100%;
          background-color: pink;
          cursor: pointer;
          .bottom_box {
            position: absolute;
            bottom: 0rem;
            left: 0rem;
            height: 0.236rem;
            background: #00000070;
            width: 100%;
            line-height: 0.236rem;
            font-size: 0.1058rem;
            color: #fff;
          }
        }
      }
    }
  }
  .option_box {
    display: flex;
    justify-content: center;
    padding: 0rem 1.875rem;
    margin-top: 0.2604rem;
    margin-bottom: 0.121rem;
    .li {
      display: inline-block;
      position: relative;
      width: 0.7083rem;
      height: 0.2969rem;
      border: 0.0052rem solid #999999;
      opacity: 1;
      border-radius: 0px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      line-height: 0.2969rem;
      color: #444444;
      font-size: 0.0833rem;
      opacity: 1;
      transition: 0.3s;
      cursor: pointer;
      margin: 0 0.1042rem;
      .Ground {
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0rem;
        left: 0rem;
        z-index: -1;
        transition: 0.3s;
        background: linear-gradient(270deg, #e71623 0%, #f5c071 100%);
      }
    }
    .liSelected {
      border: 0.0052rem solid #99999900 !important;
      color: #fff !important;
    }
    .li:hover {
      color: #fff;
      .Ground {
        opacity: 1 !important;
      }
    }
  }
  .Journalism_ul {
    padding: 0rem 1.875rem;
    overflow: hidden;
    .li {
      height: 1.3021rem;
      margin-top: 0.1563rem;
      display: flex;
      cursor: pointer;
      .time {
        width: 0.6563rem;
        height: 100%;
        color: #666666;
        .year {
          font-size: 0.0938rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.125rem;
          letter-spacing: 0.0052rem;
          opacity: 1;
          margin-top: 0.4063rem;
          transition: 0.3s;
        }
        .spot {
          width: 0.5156rem;
          height: 0px;
          border: 0.0052rem dashed #666666;
          opacity: 1;
          margin: 0.0521rem auto 0.0781rem;
          transition: 0.3s;
        }
        .day {
          font-size: 0.1563rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.125rem;
          letter-spacing: 0.0052rem;
          opacity: 1;
          transition: 0.3s;
        }
      }
      .img_box {
        width: 2.0833rem;
        height: 100%;
        background-color: skyblue;
      }
      .text {
        text-align: left;
        flex: 1;
        .title {
          font-size: 0.1354rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          letter-spacing: 0.0052rem;
          opacity: 1;
          margin-top: 0.2708rem;
          padding: 0 0.1042rem;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          display: -webkit-box;
          -webkit-line-clamp: 1; // 超出多少行
          -webkit-box-orient: vertical;
        }
        p {
          padding: 0.1042rem;
          font-size: 0.0938rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1667rem;
          color: #666666;
          letter-spacing: 0.0052rem;
          opacity: 1;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          display: -webkit-box;
          -webkit-line-clamp: 4; // 超出多少行
          -webkit-box-orient: vertical;
        }
      }
    }
    .li:hover {
      .time {
        color: #e71623 !important;
      }
      .spot {
        border: 0.0052rem dashed #e71623;
      }
    }
  }
  .paging {
    margin-top: 0.1563rem;
    text-align: center;
    padding: 0.1021rem 1.875rem;
    span {
      display: inline-block;
      width: 0.4688rem;
      height: 0.2031rem;
      background: #ffffff;
      border: 0.0052rem solid #dbdbdb;
      opacity: 1;
      border-radius: 0.0208rem;
      line-height: 0.2031rem;
      margin: 0rem 0.026rem;
      cursor: pointer;
      font-size: 0.0729rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
      user-select: none;
      background-color: #fff;
      transition: 0.3s;
    }
    .spanselect {
      background-color: #ff6100;
      color: #fff;
    }
  }
}
</style>